import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import PayorCreateForm from "./-form";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { PayorCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/_admin/payor/create")({
  component: PayorCreatePage,
});

function PayorCreatePage() {
  const navigate = useNavigate();

  return (
    <div>
      <title>Create Payor - Legrande Health Portal</title>
      <PayorCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>New Payor</CardTitle>
          <CardDescription>Enter payor details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <PayorCreateForm
            onSuccess={(response) => {
              navigate({
                to: "/payor/$payorId",
                params: { payorId: String(response.payor_id) },
              });
            }}
            onCancelBtn={
              <Button variant="outline" asChild>
                <Link to="/payor/lookup">Cancel</Link>
              </Button>
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}
